import styled from '@emotion/styled'
import { space, SpaceProp } from '../utils'
import { ColorMods } from 'components/styles/primitives/modifiers/text/colorMods'
import { TextMods } from 'components/styles/primitives/modifiers/text/textMods'
import { BorderMods, BorderProps } from 'components/styles/primitives/modifiers/shape/borders'
import { CornerMods, CornerProps } from 'components/styles/primitives/modifiers/shape/corners'
import { SizeMods, SizeProps } from 'components/styles/primitives/modifiers/size'
import { Modifiable, Mods } from 'components/styles/primitives/core/mods'

type AlignTypes = 'left' | 'right' | 'center'

interface BoxProps {
	color?: string
	background?: string
	align?: AlignTypes
}

type Props = SpaceProp & CornerProps & BorderProps & SizeProps & BoxProps

/**
 * A UI Primitive that allows common design system styles isolated within its borders.
 * Use this instead of defining custom styles
 * https://every-layout.dev/layouts/box/
 * @param {string} color
 * @param {string} background
 * @param {SpaceSize} space - Box padding
 * @param {BorderTypes} border
 * @param {CornerTypes} corners - BorderRadius / Corner Styles
 * @param {number} elevation - Adjusts Shadows
 */
export const Box = styled.div<Props & Mods>`
	padding: ${space};
	${CornerMods};
	${ColorMods};
	${BorderMods};
	${TextMods};
	${SizeMods};
	${Modifiable};
`
